import { ReactElement } from 'react';
import styles from '@/styles/components/shade-loding.module.less';
import TokenName from '../token/TokenName';
import { useTranslation } from '@/services';
const TicketLoad = (props: SwapLoadData): ReactElement => {
    const { t } = useTranslation('common', 'shade');
    return (
        <div className={styles['mint']}>
            {t('ticket-pay')}&nbsp;
            <span>
                <TokenName token={props.tokenSymbol} />
            </span>
            &nbsp; {t('ticket-amount')} <span>{props.token}</span> <br />
        </div>
    );
};

export default TicketLoad;
